import React from "react";
import './Footer.css';
import logoFacebook from '../asset/image/facebook.png';
import logoTel from '../asset/image/telephone-intelligent.png';
import logoMail from '../asset/image/enveloppe.png';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="texte">
          <h3><a href="/mentions-legales">Mentions Légales</a></h3>
          <h3><a href="#contacts">Contacts</a></h3>
        </div>
        <div className="logoContact">
          {/* Lien vers Facebook */}
          <a
            href="https://www.facebook.com/lestontonsfriteurs"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
          >
            <img src={logoFacebook} alt="Facebook" className="social-icon" />
          </a>
          {/* Lien vers un appel téléphonique */}
          {/* <a href="tel:+33770293981" className="social-link">
            <img src={logoTel} alt="Téléphone" className="social-icon" />
          </a> */}
          {/* Lien vers un email */}
          {/* <a href="mailto:les.tontons.friteurs@hotmail.fr" className="social-link">
            <img src={logoMail} alt="Email" className="social-icon" />
          </a> */}
        </div>
      </div>
      <div className="copyright">
        <p>&copy; {new Date().getFullYear()} Les Tontons Friteurs. Tous droits réservés.</p>
      </div>
    </footer>
  );
};

export default Footer;
